/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import LoadingSkeleton from 'bundles/grading/components/common/LoadingSkeleton';

const styles = {
  container: css`
    padding: 0 var(--cds-spacing-1000) var(--cds-spacing-600);
    max-width: 896px;
    margin: 0 auto;
    overflow: hidden;
    mask-image: linear-gradient(to bottom, #000 50%, transparent 100%);
  `,
  submissionHeadingLazyLoad: css`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: var(--cds-spacing-300) 0;
    margin-bottom: var(--cds-spacing-600);
  `,
};

// Container for SGA left panel related components
const SGALazyLoadMiddlePanel = () => {
  return (
    <div css={styles.container}>
      <div css={styles.submissionHeadingLazyLoad}>
        <LoadingSkeleton width="15vw" height="28px" />
        <LoadingSkeleton width="15vw" height="28px" />
      </div>
      <LoadingSkeleton width="100%" height="200px" />
    </div>
  );
};

export default SGALazyLoadMiddlePanel;
